import React, { useEffect, useRef, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  IconButton,
  Radio,
  Grid,
  CircularProgress,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useLocation, useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  startOverAPICall,
  bankDetailsAPICall,
  stageDetailsAPICall,
  NewReversePennyDropRequestAPICall,
  GetReversePennyDropStatusAPICall,
  SubmitReversePennyDropAPICall,
} from "../shared/APICalls";
import {
  IBankDetails,
  IBankPrefillData,
  IRevesePennyDropBankDetails,
} from "../shared/dtos";
import routesData from "../shared/routes.json";
import BankStyles from "../pages/Styles/BankDetails.module.scss";
import eyeIcon1 from "../Components/assets/Images/eye-slash.svg";
import eyeIcon2 from "../Components/assets/Images/eyeClose.svg";
import upiImage from "../Components/assets/Images/newupiicon.svg";
import paymentappsicons from "../Components/assets/Images/paymentappsicons.svg";
import manualImage from "../Components/assets/Images/newbankicon.svg";
import electric_bolt from "../Components/assets/Images/electric_bolt.svg";
import Box from "@mui/material/Box";
import SnackBar from "../Components/SnackBars/SnackBar";
import BackDrop from "../Components/BackDrop";
import BankSnackBar from "../Components/SnackBars/BankSnackBar";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import JsonStyles from "../Components/JsonDataToAadhaarFormat/JsonData.module.scss";
import SucessSnackBar from "../Components/SnackBars/SucesssnackBar";
import GpayIcon from "../Components/assets/Images/gpayicon.svg";
import PhonepeIcon from "../Components/assets/Images/phonepayicon.svg";
import PaytmIcon from "../Components/assets/Images/paytmicon.svg";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/bankicongrey.svg";
import backicon from "../Components/assets/Images/back.svg";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import { useDispatch } from "react-redux";
import TagManager from "react-gtm-module";
import ProgressComp from "../Components/ProgressComp/ProgressComp";
import QRCode from "react-qr-code";
import SideBar from "../Components/SideBar/SideBar";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ProgressBar from "../Components/ProgressBar/ProgressBar";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MenuIcon from "@mui/icons-material/Menu";
import { isMobile } from "react-device-detect";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const schema = Yup.object().shape({
  bankAccountNumber: Yup.string()
    .required("Account Number is Required")
    .min(6, "Bank account number should be minimum 6 characters")
    .max(18, "Bank account number should be maximum 18 characters")
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid Account Number")
    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .transform((value: any) => value && value.toUpperCase()),

  ConfirmBankAccountNumber: Yup.string()
    .required("Confirm Account Number is Required")
    .min(6, "Confirm Bank account number should be minimum 6 characters")
    .max(18, "Confirm Bank account number should be maximum 18 characters")
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid Account Number")
    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .transform((value: any) => value && value.toUpperCase())
    .test(
      "match",
      "Account Number and Confirm Account Number should match",
      function (value) {
        return value === this.parent.bankAccountNumber;
      },
    ),

  ifscNumber: Yup.string()
    .required("IFSC is Required")
    .max(11, "Ifsc number should be maximum 11 characters")
    .min(3, "Minimum 3 letters is required")
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid IFSC")
    .transform((value: any) => value && value.toUpperCase()),

  // micrNumber: Yup.string()
  //   .required("MICR is Required")
  //   .max(11)
  //   .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid MICR")
  //   .transform((value: any) => value && value.toUpperCase()),

  customerNameAsperBank: Yup.string()
    .required("Name is Required")
    .max(50, "Customer name as per bank should be maximum 50 characters")
    // .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .min(3, "Minimum 3 letters is required")
    // .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
    .transform((value: any) => value && value.toUpperCase()),

  // accountType: Yup.object().required("Please select an option"),
});
const accountItems = [
  {
    id: "Current",
    sequence: 1,
    value: "Current",
  },
  {
    id: "Savings",
    sequence: 2,
    value: "Savings",
  },
];

export default function LinkUsingIFSC() {
  const pathName = useLocation().pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showAccountNumber, setShowAccountNumber] = React.useState(false);
  const [loading, setloading] = useState(false);
  const [prefilloading, setprefilloading] = useState(true);
  const [startOverloading, setstartOverloading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");
  const [value, setValue] = React.useState(0);

  const [upiID, setUpiId] = useState("");
  const [ifscData, setIFSCData] = useState<any>({
    Bank: "",
    Address: "",
  });

  const [prefillData, setprefillData] = useState<IBankPrefillData>({
    bankAccountNumber: "",
    ConfirmBankAccountNumber: "",
    ifscNumber: "",
    customerNameAsperBank: "",
    // micrNumber: "",
  });
  const [rejectMessage, setRejectMessage] = useState("");
  const [bgColor1, setbgcolor1] = useState("var(--ds-card)");
  const [bgColor2, setbgcolor2] = useState("var(--ds-bg)");
  const [selectedValue, setSelectedValue] = useState("a");
  const [displayManualEnter, setDisplayManualEnter] = useState(false);
  const [upiMode, setUPIMode] = useState(false);
  const [backdrop, setBackDrop] = useState(false);
  const [circularloader, setcircularLoader] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [getStatus, setGetStatus] = useState(false);
  const [agentPlatform, setAgentPlatform] = useState("");
  const [micrNumber, setMicrNumber] = useState("");
  const [stautsdata, setstatusdata] = useState<any>();
  const [count, setcount] = useState(0);
  const [expandMenu, setExpandMenu] = useState<any>(false);

  const [setuDetails, setSetuDetails] = useState({
    id: "",
    // shortUrl: "",
    upiLink: "",
  });

  const [bankDetailsFetched, setBankDetailsFetched] = useState<any>({
    accountType: "",
    bankAccountIfsc: "",
    bankAccountName: "",
    bankAccountNumber: "",
    payerVpa: "",
    ifscDetails: { address: "", branch: "", micr: "", name: "" },
  });

  const [fetchedbankDetails, setfetchedbankDetails] = useState({
    bankAddress: "",
    bankName: "",
    branchName: "",
  });
  const [statusError, setStatusError] = useState("");
  const [id, setid] = useState("");

  const pollingIntervalRef = useRef<any>(null);

  const upiWindowRef = useRef<Window | null>(null);
  const upiWindowCloseIntervalRef = useRef<number | null>(null);

  const closeUPIWindow = React.useCallback(() => {
    if (upiWindowCloseIntervalRef.current !== null) {
      window.clearInterval(upiWindowCloseIntervalRef.current);
      upiWindowCloseIntervalRef.current = null;
    }
    if (upiWindowRef.current && !upiWindowRef.current.closed) {
      upiWindowRef.current.close();
    }
    // setUPIMode(false);
    upiWindowRef.current = null;

    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
  }, []);

  const beforeUnloadRef: any = useRef();

  const navigationData = routesData;
  const handleClickShowAccountNumber = () =>
    setShowAccountNumber((show) => !show);

  const handleMouseDownAccountNumber = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  // useEffect(() => {
  //   if (value === 1) {
  //     beforeUnloadRef.current = (event) => {
  //       const confirmationMessage = "Saved Data Will be Lost?";
  //       event.returnValue = confirmationMessage;
  //       return confirmationMessage;
  //     };
  //     window.addEventListener("beforeunload", beforeUnloadRef.current);
  //   }

  //   return () => {
  //     if (value === 1) {
  //       window.removeEventListener("beforeunload", beforeUnloadRef.current);
  //     }
  //   };
  // }, [value]);

  const handleMobilePaymentLink = () => {
    // setTimeout(() => {
    //   if (value === 1) {
    //     window.removeEventListener("beforeunload", beforeUnloadRef.current);
    //   }
    // });
  };

  useEffect(() => {
    return () => {
      closeUPIWindow();
    };
  }, [closeUPIWindow]);

  useEffect(() => {
    window.scrollTo(0, 0);

    checkUserLoggedIn(navigate);
    setprefilloading(true);
    let obj: any = {
      stage: "bank",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        setprefilloading(false);
        const responseData = response.data;
        dispatch(setCompletedStages(responseData?.data?.completed_stages));
        dispatch(setCurrentStage(responseData?.data?.current_stage));
        setRejectMessage(responseData?.data?.ErrorMessage);

        if (
          responseData?.data?.data?.bank_details &&
          responseData?.data?.data?.bank_details[0]
        ) {
          if (responseData?.data?.data?.bank_details[0]?.account_no) {
            setDisplayManualEnter(true);
            setUPIMode(false);
          }
          setfetchedbankDetails({
            bankAddress: responseData?.data?.data?.bank_details[0]?.address,
            bankName: responseData?.data?.data?.bank_details[0]?.bank_name,
            branchName: responseData?.data?.data?.bank_details[0]?.branch_name,
          });
          setIFSCData({
            Bank: responseData?.data?.data?.bank_details[0]?.bank_name,
            Address: responseData?.data?.data?.bank_details[0]?.branch_name,
          });

          setprefillData((prev) => {
            return {
              ...prev,
              bankAccountNumber:
                responseData?.data?.data?.bank_details[0]?.account_no || "",
              ConfirmBankAccountNumber:
                responseData?.data?.data?.bank_details[0]?.account_no || "",
              ifscNumber: responseData?.data?.data?.bank_details[0]?.ifsc || "",
              customerNameAsperBank:
                responseData?.data?.data?.bank_details[0]?.customer_name !== ""
                  ? responseData?.data?.data.bank_details[0]?.customer_name
                  : responseData?.data?.data?.bank_details[0]?.customer_name,
            };
          });
          if (responseData?.data?.data?.bank_details[0]?.micr) {
            setMicrNumber(responseData?.data?.data?.bank_details[0]?.micr);
          }

          setBankDetailsFetched((prev) => {
            return {
              ...prev,
              bankAccountNumber:
                responseData?.data?.data?.bank_details[0]?.account_no,
              ConfirmBankAccountNumber:
                responseData?.data?.data?.bank_details[0]?.account_no,
              bankAccountIfsc: responseData?.data?.data?.bank_details[0]?.ifsc,
              bankAccountName:
                responseData?.data?.data?.bank_details[0]?.customer_name,
              accountType: "Savings",
              payerVpa: responseData?.data?.data?.bank_details[0]?.upi
                ? responseData?.data?.data?.bank_details[0]?.upi
                : "",
              ifscDetails: {
                name: responseData?.data?.data?.bank_details[0]?.bank_name,
                address: responseData?.data?.data?.bank_details[0]?.address,
                micr: responseData?.data?.data?.bank_details[0]?.micr,
                branch: responseData?.data?.data?.bank_details[0]?.branch_name,
              },
            };
          });
          if (
            responseData?.data?.data?.bank_details[0]?.upi &&
            responseData?.data?.data?.bank_details[0]?.upi !== ""
          ) {
            setValue(1);
            setDisplayManualEnter(false);
            setUPIMode(true);
            setUpiId(responseData?.data?.data?.bank_details[0]?.upi);
          }
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
        setprefilloading(false);
      });

    const userAgent = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(userAgent)) {
      setAgentPlatform("iOS");
    } else if (/android/.test(userAgent)) {
      setAgentPlatform("Android");
    } else {
      setAgentPlatform("Other");
    }

    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
  }, []);

  const handleUpdate = () => {
    if (isMobile) {
      setUpiId("");

      setBankDetailsFetched({
        accountType: "",
        bankAccountIfsc: "",
        bankAccountName: "",
        bankAccountNumber: "",
        ifscDetails: { address: "", branch: "", name: "", micr: "" },
      });
    }
    handleContinuewithUPI();
  };

  // useEffect(() => {
  //   if (getStatus === true) {
  //     getReversePennyDropStatus();
  //   }
  // }, [getStatus]);

  // useEffect(() => {
  //   if (value === 1 && setuDetails.id) {
  //     getReversePennyDropStatus();
  //   }
  // }, [value, setuDetails.id]);

  //  console.log(pathName);

  const getReversePennyDropStatus = (setu_id: any) => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }
    console.log("setu_id", setu_id);
    pollingIntervalRef.current = setInterval(() => {
      GetReversePennyDropStatusAPICall({ penny_drop_id: setu_id })
        .then((response: any) => {
          const responseData = response.data;

          // console.log("responseData", responseData.data.data === null);
          if (responseData?.data?.data !== null) {
            // setStatusError("200, Data  received");
            if (pollingIntervalRef.current) {
              clearInterval(pollingIntervalRef.current);
            }
            if (responseData?.data?.data?.ifscCrossCheck === true) {
              setSuccessMessage("Bank Details Fetched Successfully");
              setTimeout(() => {
                setSuccessMessage("");
              }, 5000);
              closeUPIWindow();
              setBankDetailsFetched(responseData?.data?.data);
              setUpiId(responseData?.data?.data?.payerVpa);
              // toast.custom(
              //   <Snackbar type="s" msg={"Bank Details Fetched Successfully"} />,
              // );
            } else if (responseData?.data?.data?.ifscCrossCheck === false) {
              // setShowAddModal(true);
              // setUPIMode(false);
              closeUPIWindow();

              setErrorMessage(
                "Error Fetching Bank Details, Enter Details Manually",
              );
              setTimeout(() => {
                setErrorMessage("");
              }, 5000);
            }
          } else {
            // setUPIMode(false);
            // setStatusError("200, Data not received");
          }
        })
        .catch((error: any) => {
          // setStatusError(`"400, Failed"${JSON.stringify(error?.code)}`);
          if (error?.code !== "ERR_BAD_REQUEST") {
            getReversePennyDropStatus(setu_id);
          } else {
            setUPIMode(false);
            closeUPIWindow();

            setErrorMessage(
              error?.response?.data?.message
                ? error?.response?.data?.message
                : "Transaction failed",
            );
            setTimeout(() => {
              setErrorMessage("");
            }, 5000);
            if (pollingIntervalRef.current) {
              clearInterval(pollingIntervalRef.current);
            }
          }
        });
    }, 2000);
  };

  const handleContinueNext = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitBank",
      },
    });

    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }
    setloading(true);
    let obj: IRevesePennyDropBankDetails = {
      upi: bankDetailsFetched?.payerVpa,
      bank_type: "savings",
      ifsc: bankDetailsFetched?.bankAccountIfsc?.toUpperCase(),
      micr: bankDetailsFetched.ifscDetails?.micr,
      bank_account_number: bankDetailsFetched?.bankAccountNumber,
      customer_name_in_bank: bankDetailsFetched.bankAccountName?.toUpperCase(),
      bank_address: bankDetailsFetched?.ifscDetails?.address?.toUpperCase(),
      bank_name: bankDetailsFetched.ifscDetails?.name?.toUpperCase(),
      branch_name: bankDetailsFetched?.ifscDetails?.branch?.toUpperCase(),
      reference_id: setuDetails?.id,
      penny_drop_log: bankDetailsFetched,
    };
    // console.log("bankDetailsFetched", bankDetailsFetched);
    SubmitReversePennyDropAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData", responseData);

        // window.alert(responseData.pennyDropUpdate);
        setloading(false);
        if (
          responseData?.data?.next_stage &&
          navigationData.hasOwnProperty(responseData?.data?.next_stage)
        ) {
          navigate(navigationData[responseData?.data?.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);

        setMessage(
          error?.message.includes("Network")
            ? "Error occured, Please try again"
            : error?.response?.data?.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  };

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setstartOverloading(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                // console.log("responseData", response);
                setstartOverloading(false);
                navigate("/");
              })
              .catch((error: any) => {
                setstartOverloading(false);
              });
          },
        },
      ],
    });
  };

  const handleChangeField = (
    name: string,
    value: any,
    callBack: any,

    values: any,
  ) => {
    const ifscCode = value?.toUpperCase();
    console.log(ifscCode);
    callBack(name, ifscCode);
    if (ifscCode.length === 11) {
      fetch(`https://ifsc.razorpay.com/${ifscCode}`)
        .then((response) => response.json())
        .then((data) => {
          // callBack("micrNumber", data.MICR === null ? "Not Found" : data.MICR);
          setMicrNumber(data.MICR === null ? "" : data.MICR);
          // console.log("data", data);
          if (data === "Not Found") {
            setErrorMessage("Please enter Valid IFSC");
            setIFSCData({
              Bank: "",
              Address: "",
            });
          }
          if (data !== "Not Found") {
            setfetchedbankDetails({
              bankAddress: data.ADDRESS,
              bankName: data.BANK,
              branchName: data.BRANCH,
            });
            setIFSCData({
              Bank: data.BANK,
              Address: data.BRANCH,
            });
          }
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        })
        .catch((error) => {
          // console.log(error);
        });
    }

    if (ifscCode.length < 11) {
      setIFSCData({
        Bank: "",
        Address: "",
      });
    }
  };

  function bankDetails(data: any) {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitBank",
      },
    });
    setloading(true);
    let obj: IBankDetails = {
      bank_type: "savings",
      ifsc: data?.ifscNumber?.toUpperCase(),
      micr: micrNumber,
      bank_account_number: data?.bankAccountNumber,
      customer_name_in_bank: data?.customerNameAsperBank?.toUpperCase(),
      bank_address: fetchedbankDetails?.bankAddress?.toUpperCase(),
      bank_name: fetchedbankDetails?.bankName?.toUpperCase(),
      branch_name: fetchedbankDetails?.branchName?.toUpperCase(),
    };
    bankDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response?.data;
        if (pollingIntervalRef.current) {
          clearInterval(pollingIntervalRef.current);
        }

        setloading(false);
        if (
          responseData?.data?.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
          // window.location.href = navigationData[responseData.data.next_stage];
        }
      })
      .catch((error: any) => {
        setloading(false);
        setMessage(error?.response?.data?.message);
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  const InitialValues: IBankPrefillData = {
    bankAccountNumber: prefillData.bankAccountNumber,
    ConfirmBankAccountNumber: prefillData.ConfirmBankAccountNumber,
    ifscNumber: prefillData.ifscNumber,
    customerNameAsperBank: prefillData.customerNameAsperBank || "",
    // accountType: prefillData.accountType,
    // micrNumber: prefillData.micrNumber,
  };

  const handleContinuewithUPI = () => {
    window.scrollTo(0, 0);
    setcircularLoader(true);
    setDisplayManualEnter(false);
    setUPIMode(true);
    // if (selectedValue === "a") {
    //   setTimeout(() => {
    //     setcircularLoader(true);
    //   }, 2000);
    // } else {
    //   setcircularLoader(false);
    // }
    NewReversePennyDropRequestAPICall({})
      .then((response: any) => {
        const responseData = response.data;
        //console.log("responseData", responseData);
        if (responseData?.data?.id) {
          if (!isMobile) {
            closeUPIWindow();
            upiWindowRef.current = window.open(
              responseData?.data?.upiLink,
              "reversePennyDropUPI",
              "popup=yes,width=500,height=700",
            );
            if (upiWindowRef.current) {
              upiWindowCloseIntervalRef.current = window.setInterval(() => {
                if (upiWindowRef.current?.closed) {
                  closeUPIWindow();
                  setUPIMode(false);
                }
              }, 500);
            } else {
              setUPIMode(false);
              setErrorMessage(
                "Pop-up blocked. Please allow pop-ups in your browser and try again.",
              );
              setTimeout(() => {
                setErrorMessage("");
              }, 5000);
            }
          }

          setSetuDetails({
            id: responseData?.data?.id,
            // shortUrl: responseData?.data?.shortUrl,
            upiLink: responseData?.data?.upiLink,
          });
          getReversePennyDropStatus(responseData?.data?.id);
        }
      })
      .catch((error: any) => {
        //  console.log("error", error);
      });
    if (setuDetails.id) {
    }
  };
  const handleContinueManually = () => {
    window.scrollTo(0, 0);
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }
    setDisplayManualEnter(true);
    setUPIMode(false);
  };
  // console.log("pollingIntervalRef", pollingIntervalRef.current);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  const handleBackClickManual = () => {
    window.scrollTo(0, 0);
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }
    setDisplayManualEnter(false);
    setUPIMode(false);
    setprefillData({
      bankAccountNumber: "",
      ConfirmBankAccountNumber: "",
      ifscNumber: "",
      customerNameAsperBank: "",
      // micrNumber: "",
    });
    setIFSCData({
      Bank: "",
      Address: "",
    });
  };
  const handleBackClick = () => {
    window.scrollTo(0, 0);
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }
    setDisplayManualEnter(false);
    setUPIMode(false);
  };
  const handleDoManuallyClick = () => {
    window.scrollTo(0, 0);
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }
    setDisplayManualEnter(false);
    setUPIMode(false);
  };

  return (
    <>
      <ErrorSnackBar message={rejectMessage} />
      <SucessSnackBar message={successMessage} />
      <SnackBar message={errorMessage} />
      <SnackBar message={message} />
      {backdrop && <StartOverBackDrop />}
      <div className={BankStyles.layout}>
        <div className={BankStyles.sidebar}>
          <SideBar />
        </div>
        <div className={BankStyles.pageContent}>
          <div className={BankStyles.mainWrapperTop}>
            {displayManualEnter && (
              <div className={BankStyles.wrapper}>
                {!prefilloading ? (
                  <Formik
                    validationSchema={schema}
                    initialValues={InitialValues}
                    onSubmit={(values: any) => {
                      // console.log("values", values);
                      if (pollingIntervalRef.current) {
                        clearInterval(pollingIntervalRef.current);
                      }
                      bankDetails(values);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      resetForm,
                      setFieldValue,
                    }) => {
                      // console.log("errors", errors);
                      return (
                        <form
                          autoComplete="off"
                          noValidate
                          onSubmit={handleSubmit}
                          onKeyDown={(event) => {
                            event.code === "Enter" ||
                              (event.code === "NumpadEnter" && handleSubmit());
                            // event.code.includes("Enter") && handleSubmit()
                          }}
                          className={BankStyles.form}
                        >
                          <div className={BankStyles.container}>
                            <div className={BankStyles.headerSection}>
                              <p className={BankStyles.signup}>
                                <div className={BankStyles.mobileBack}>
                                  <ArrowBackIosIcon
                                    onClick={() => {
                                      handleBackClickManual();
                                    }}
                                  />
                                </div>
                                Bank Details{" "}
                                <div
                                  className={BankStyles.mobileMenu}
                                  onClick={() => {
                                    setExpandMenu(!expandMenu);
                                  }}
                                >
                                  {expandMenu ? <CloseIcon /> : <MenuIcon />}
                                </div>
                              </p>
                              <ProgressBar />
                              <div
                                className={BankStyles.mobileexpandedMenu}
                                style={{
                                  height: expandMenu ? "100%" : "0%",
                                }}
                              >
                                <div className={BankStyles.mobilemenuContent}>
                                  <SideBar />
                                </div>
                              </div>
                              <p
                                className={BankStyles.subText}
                                style={{ width: "100%" }}
                              >
                                We need these details only to verify that this
                                bank account belongs to you.
                              </p>
                            </div>

                            {prefillData?.bankAccountNumber !== "" ? (
                              <div className={BankStyles.containerData}>
                                <Grid
                                  container
                                  rowSpacing={{ xs: 2, sm: 6 }}
                                  columnSpacing={{ xs: 1, sm: 2, md: 5 }}
                                >
                                  <Grid item xs={12} md={3}>
                                    <div className={BankStyles.itemWrap}>
                                      <div className={BankStyles.labeltextNew}>
                                        Name as per Bank Record
                                      </div>
                                      <div className={BankStyles.value}>
                                        {prefillData?.customerNameAsperBank}
                                      </div>
                                    </div>
                                  </Grid>
                                  <Grid item xs={12} md={3}>
                                    <div className={BankStyles.itemWrap}>
                                      <div className={BankStyles.labeltextNew}>
                                        Bank Name
                                      </div>
                                      <div className={BankStyles.value}>
                                        {fetchedbankDetails?.bankName}
                                      </div>
                                    </div>
                                  </Grid>
                                  <Grid item xs={12} md={3}>
                                    <div className={BankStyles.itemWrapLast}>
                                      <div className={BankStyles.labeltextNew}>
                                        Bank Account Number
                                      </div>
                                      <div className={BankStyles.value}>
                                        {prefillData?.bankAccountNumber}
                                      </div>
                                    </div>
                                  </Grid>
                                  <Grid item xs={12} md={3}>
                                    <div className={BankStyles.labeltextNew}>
                                      Branch’s IFSC Code
                                    </div>
                                    <div className={BankStyles.value}>
                                      {prefillData?.ifscNumber}
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            ) : (
                              <div className={BankStyles.fieldsWrapper}>
                                <div className={BankStyles.feildSection}>
                                  <div className={BankStyles.labeltext}>
                                    Full Name As Per Bank Account
                                  </div>
                                  <TextField
                                    autoComplete="off"
                                    className={BankStyles.textfeild}
                                    id="outlined-basic"
                                    placeholder="Full Name As Per Bank Account"
                                    variant="outlined"
                                    name="customerNameAsperBank"
                                    disabled={
                                      prefillData?.bankAccountNumber !== ""
                                    }
                                    // disabled={!editcustomerName}
                                    value={values.customerNameAsperBank?.toUpperCase()}
                                    error={
                                      touched.customerNameAsperBank &&
                                      Boolean(errors.customerNameAsperBank)
                                    }
                                    helperText={
                                      touched.customerNameAsperBank &&
                                      errors.customerNameAsperBank?.toString()
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    inputProps={{
                                      sx: {
                                        "&::label": {
                                          fill: "var(--ds-text-primary)",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        },
                                        color: "var(--ds-text-primary)",
                                        fontSize: "14px",
                                        "&::placeholder": {
                                          color: "var(--ds-text-secondary)",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          opacity: 0.6,
                                        },
                                      },
                                      maxLength: 50,
                                      inputMode: "text",
                                      form: {
                                        autoComplete: "off",
                                      },
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                      },
                                      "& .Mui-disabled": {
                                        backgroundColor:
                                          "transparent !important",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "var(--ds-text-secondary)",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        // marginTop:"2px",
                                        "&.MuiFormLabel-filled": {
                                          color: "var(--ds-text-primary)",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          fontFamily: "inherit",
                                        },
                                      },
                                    }}
                                  />
                                </div>
                                <div className={BankStyles.feildSection}>
                                  <input
                                    type="text"
                                    name="ifscNumber"
                                    style={{ display: "none" }}
                                  />
                                  <div className={BankStyles.labeltext}>
                                    Branch's IFSC
                                  </div>
                                  <TextField
                                    autoComplete="new-password"
                                    className={BankStyles.textfeild}
                                    id="outlined-basic-ifsc-new"
                                    placeholder="Branch's IFSC"
                                    variant="outlined"
                                    name="ifscNumber"
                                    value={values.ifscNumber?.toUpperCase()}
                                    disabled={
                                      prefillData?.bankAccountNumber !== ""
                                    }
                                    error={
                                      touched.ifscNumber &&
                                      Boolean(errors.ifscNumber)
                                    }
                                    helperText={
                                      touched.ifscNumber &&
                                      errors.ifscNumber?.toString()
                                    }
                                    onChange={(event) => {
                                      handleChangeField(
                                        "ifscNumber",
                                        event.target.value,
                                        setFieldValue,

                                        values,
                                      );
                                    }}
                                    onKeyDown={(event) => {
                                      if (event.key === " ") {
                                        event.preventDefault();
                                      }
                                    }}
                                    onBlur={handleBlur}
                                    inputProps={{
                                      sx: {
                                        "&::label": {
                                          fill: "var(--ds-text-primary)",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        },
                                        color: "var(--ds-text-primary)",
                                        fontSize: "14px",
                                        "&::placeholder": {
                                          color: "var(--ds-text-secondary)",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          opacity: 0.6,
                                        },
                                      },
                                      maxLength: 11,
                                      inputMode: "text",
                                      form: {
                                        autoComplete: "off",
                                      },
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                      },
                                      "& .Mui-disabled": {
                                        backgroundColor:
                                          "transparent !important",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "var(--ds-text-secondary)",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        // marginTop:"2px",
                                        "&.MuiFormLabel-filled": {
                                          color: "var(--ds-text-primary)",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          fontFamily: "inherit",
                                        },
                                      },
                                    }}
                                  />

                                  <BankSnackBar message={ifscData} />
                                </div>

                                <div className={BankStyles.feildSection}>
                                  <div className={BankStyles.labeltext}>
                                    Bank Account Number
                                  </div>
                                  <TextField
                                    autoComplete="new-password"
                                    className={BankStyles.textfeild}
                                    disabled={
                                      prefillData?.bankAccountNumber !== ""
                                    }
                                    id="outlined-basic"
                                    placeholder="Bank Account Number"
                                    variant="outlined"
                                    name="bankAccountNumber"
                                    type="password"
                                    value={values.bankAccountNumber?.toUpperCase()}
                                    error={
                                      touched.bankAccountNumber &&
                                      Boolean(errors.bankAccountNumber)
                                    }
                                    helperText={
                                      touched.bankAccountNumber &&
                                      errors.bankAccountNumber?.toString()
                                    }
                                    onChange={(e) => {
                                      const value = e.target.value.replace(
                                        /\s/g,
                                        "",
                                      );
                                      setFieldValue("bankAccountNumber", value);
                                    }}
                                    onBlur={handleBlur}
                                    inputProps={{
                                      sx: {
                                        "&::label": {
                                          fill: "var(--ds-text-primary)",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        },
                                        color: "var(--ds-text-primary)",
                                        fontSize: "14px",
                                        "&::placeholder": {
                                          color: "var(--ds-text-secondary)",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          opacity: 0.6,
                                        },
                                      },
                                      maxLength: 18,
                                      inputMode: "text",
                                      form: {
                                        autoComplete: "off",
                                      },
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                      },
                                      "& .Mui-disabled": {
                                        backgroundColor:
                                          "transparent !important",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "var(--ds-text-secondary)",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        // marginTop:"2px",
                                        "&.MuiFormLabel-filled": {
                                          color: "var(--ds-text-primary)",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          fontFamily: "inherit",
                                        },
                                      },
                                    }}
                                    onCopy={(e) => e.preventDefault()}
                                    onPaste={(e) => e.preventDefault()}
                                  />
                                </div>
                                <div className={BankStyles.feildSection}>
                                  <div className={BankStyles.labeltext}>
                                    Confirm Bank Account Number
                                  </div>
                                  <TextField
                                    autoComplete="off"
                                    className={BankStyles.textfeild}
                                    id="outlined-basic"
                                    placeholder="Confirm Bank Account Number"
                                    variant="outlined"
                                    name="ConfirmBankAccountNumber"
                                    disabled={
                                      prefillData?.bankAccountNumber !== ""
                                    }
                                    value={values.ConfirmBankAccountNumber?.toUpperCase()}
                                    error={
                                      touched.ConfirmBankAccountNumber &&
                                      Boolean(errors.ConfirmBankAccountNumber)
                                    }
                                    helperText={
                                      touched.ConfirmBankAccountNumber &&
                                      errors.ConfirmBankAccountNumber?.toString()
                                    }
                                    onChange={(e) => {
                                      const value = e.target.value.replace(
                                        /\s/g,
                                        "",
                                      );
                                      setFieldValue(
                                        "ConfirmBankAccountNumber",
                                        value,
                                      );
                                    }}
                                    onBlur={handleBlur}
                                    // onPaste={handlePaste}

                                    type={
                                      showAccountNumber ? "password" : "text"
                                    }
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <IconButton
                                            aria-label="toggle account number visibility"
                                            onClick={
                                              handleClickShowAccountNumber
                                            }
                                            onMouseDown={
                                              handleMouseDownAccountNumber
                                            }
                                            edge="end"
                                          >
                                            {showAccountNumber ? (
                                              <img
                                                src={eyeIcon1}
                                                width={"20px"}
                                              />
                                            ) : (
                                              <img
                                                src={eyeIcon2}
                                                width={"20px"}
                                              />
                                            )}
                                          </IconButton>
                                        </InputAdornment>
                                      ),
                                    }}
                                    onCopy={(e) => e.preventDefault()}
                                    onPaste={(e) => e.preventDefault()}
                                    inputProps={{
                                      sx: {
                                        "&::label": {
                                          fill: "var(--ds-text-primary)",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        },
                                        color: "var(--ds-text-primary)",
                                        fontSize: "14px",
                                        "&::placeholder": {
                                          color: "var(--ds-text-secondary)",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          opacity: 0.6,
                                        },
                                      },
                                      maxLength: 18,
                                      inputMode: "text",
                                      form: {
                                        autoComplete: "off",
                                      },
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                      },
                                      "& .Mui-disabled": {
                                        backgroundColor:
                                          "transparent !important",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "var(--ds-text-secondary)",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        // marginTop:"2px",
                                        "&.MuiFormLabel-filled": {
                                          color: "var(--ds-text-primary)",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                          fontFamily: "inherit",
                                        },
                                      },
                                    }}
                                  />

                                  <SnackBar message={message} />
                                </div>
                              </div>
                            )}
                          </div>

                          <div className={BankStyles.buttonStack}>
                            <div className={BankStyles.buttonSectionRight}>
                              <Button
                                variant="text"
                                sx={{
                                  color: "var(--ds-text-primary)",
                                  gap: "8px",
                                }}
                                onClick={() => {
                                  // resetForm();
                                  handleBackClickManual();
                                }}
                                className={BankStyles.backbutton}
                              >
                                <KeyboardBackspaceIcon /> Back
                              </Button>
                              <Button
                                variant="outlined"
                                sx={{
                                  color: "var(--ds-text-primary)",
                                  background: "var(--ds-bg)",
                                  border: "1px solid var(--ds-outline)",
                                }}
                                onClick={() => {
                                  // resetForm();
                                  handleBackClickManual();
                                }}
                                className={BankStyles.addaccount}
                              >
                                Add New Account
                              </Button>

                              {values.bankAccountNumber &&
                              values.ConfirmBankAccountNumber &&
                              values.customerNameAsperBank &&
                              values.ifscNumber &&
                              ifscData.Bank !== "" &&
                              !errors.ConfirmBankAccountNumber &&
                              !errors.ifscNumber &&
                              !errors.bankAccountNumber ? (
                                // values.micrNumber
                                <LoadingButton
                                  loading={loading}
                                  variant="contained"
                                  type="submit"
                                  id="linkUsingIFSCContinueButton"
                                  className={BankStyles.approveButton}
                                >
                                  Continue
                                </LoadingButton>
                              ) : (
                                <Button
                                  variant="contained"
                                  disabled
                                  className={BankStyles.approveButton}
                                >
                                  Continue
                                </Button>
                              )}
                            </div>
                          </div>
                        </form>
                      );
                    }}
                  </Formik>
                ) : (
                  <div className={BankStyles.backdropStyles}>
                    <BackDrop />
                  </div>
                )}
              </div>
            )}
            {upiMode && (
              <div className={BankStyles.wrapper}>
                <div className={BankStyles.wrapperContainer}>
                  <>
                    {upiID === "" ? (
                      <>
                        <div className={BankStyles.headerSection}>
                          <p className={BankStyles.signup}>
                            <div className={BankStyles.mobileBack}>
                              <ArrowBackIosIcon
                                onClick={() => {
                                  if (pollingIntervalRef.current) {
                                    clearInterval(pollingIntervalRef.current);
                                  }
                                  if (upiMode) {
                                    handleBackClick();
                                  } else {
                                    navigate("/profile");
                                  }
                                }}
                              />
                            </div>
                            {upiID === "" ? "Pay with UPI" : "Paid with UPI"}
                            <div
                              className={BankStyles.mobileMenu}
                              onClick={() => {
                                setExpandMenu(!expandMenu);
                              }}
                            >
                              {expandMenu ? <CloseIcon /> : <MenuIcon />}
                            </div>
                          </p>
                          <ProgressBar />
                          <div
                            className={BankStyles.mobileexpandedMenu}
                            style={{
                              height: expandMenu ? "100%" : "0%",
                            }}
                          >
                            <div className={BankStyles.mobilemenuContent}>
                              <SideBar />
                            </div>
                          </div>
                          <p
                            className={BankStyles.subText}
                            style={{ width: "100%" }}
                          >
                            Debited Amount Rs.1 will be credited back in 2
                            working days
                          </p>
                        </div>
                      </>
                    ) : (
                      <div className={BankStyles.headerSection}>
                        <p className={BankStyles.signup}>
                          <div className={BankStyles.mobileBack}>
                            <ArrowBackIosIcon
                              onClick={() => {
                                if (pollingIntervalRef.current) {
                                  clearInterval(pollingIntervalRef.current);
                                }
                                if (upiMode) {
                                  handleBackClick();
                                } else {
                                  navigate("/yourprofile");
                                }
                              }}
                            />
                          </div>{" "}
                          Fetched bank Details{" "}
                          <div
                            className={BankStyles.mobileMenu}
                            onClick={() => {
                              setExpandMenu(!expandMenu);
                            }}
                          >
                            {expandMenu ? <CloseIcon /> : <MenuIcon />}
                          </div>
                        </p>
                        <ProgressBar />
                        <div
                          className={BankStyles.mobileexpandedMenu}
                          style={{
                            height: expandMenu ? "100%" : "0%",
                          }}
                        >
                          <div className={BankStyles.mobilemenuContent}>
                            <SideBar />
                          </div>
                        </div>
                        <p
                          className={BankStyles.subText}
                          style={{ width: "100%" }}
                        >
                          Paid via UPI. ₹1 will be refunded within 2 days. To
                          retry with another bank,{" "}
                          <span
                            style={{
                              color: "#3263E5",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={handleUpdate}
                          >
                            click here.
                          </span>
                        </p>
                      </div>
                    )}
                  </>

                  {bankDetailsFetched.bankAccountNumber === "" &&
                  upiID === "" ? (
                    <>
                      <Stack
                        height={"60%"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        display={{ xs: "none", sm: "flex" }}
                      >
                        <CircularProgress />
                      </Stack>

                      {/* <div className={BankStyles.buttonBackStyles}>
                        <Button
                          className={BankStyles.buttonBackStyles}
                          variant="contained"
                          onClick={handleBackClick}
                        >
                          Back
                        </Button>
                      </div> */}
                      <div className={BankStyles.mobileUpiLink}>
                        {circularloader && (
                          <Stack height={"100px"} justifyContent={"center"}>
                            <CircularProgress />
                          </Stack>
                        )}
                        {!circularloader && (
                          <>
                            {/* {agentPlatform === "iOS" ? ( */}
                            <>
                              <div className={BankStyles.iosPaymentUI}>
                                <p className={BankStyles.selectText}>
                                  Select an app to
                                </p>
                                <p className={BankStyles.amountText}>
                                  Pay{" "}
                                  <span style={{ fontWeight: 600 }}>Rs.1</span>
                                </p>
                                <div
                                  className={BankStyles.paymentsOptionsSction}
                                >
                                  <a
                                    href={`${setuDetails.upiLink}?app=phonepe`}
                                    style={{
                                      textDecoration: "none",
                                      color: "black",
                                    }}
                                  >
                                    <div className={BankStyles.paymentOptions}>
                                      <img src={PhonepeIcon} />
                                      <p>PhonePe</p>
                                    </div>
                                  </a>
                                  <a
                                    href={`${setuDetails.upiLink}?app=gpay`}
                                    style={{
                                      textDecoration: "none",
                                      color: "black",
                                    }}
                                  >
                                    <div className={BankStyles.paymentOptions}>
                                      <img src={GpayIcon} />
                                      <p>Google Pay</p>
                                    </div>
                                  </a>
                                  <a
                                    href={`${setuDetails.upiLink}?app=paytm`}
                                    style={{
                                      textDecoration: "none",
                                      color: "black",
                                    }}
                                  >
                                    <div className={BankStyles.paymentOptions}>
                                      <img src={PaytmIcon} />
                                      <p>PayTM</p>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </>
                            {/* ) : (
                        <a
                          href={setuDetails.upiLink}
                          className={BankStyles.upiLink}
                        >
                          <Button
                            variant="contained"
                            sx={{ width: "250px" }}
                            onClick={handleMobilePaymentLink}
                          >
                            Pay Rs.1
                          </Button>
                        </a>
                      )} */}
                          </>
                        )}

                        <Button
                          className={BankStyles.buttonBackStyles}
                          variant="outlined"
                          sx={{ color: "#006779" }}
                          onClick={handleBackClick}
                        >
                          Back
                        </Button>
                      </div>
                    </>
                  ) : (
                    <Stack className={BankStyles.displayFetchedData}>
                      <div className={BankStyles.containerData}>
                        <Grid
                          container
                          rowSpacing={{ xs: 2, sm: 6 }}
                          columnSpacing={{ xs: 1, sm: 2, md: 5 }}
                        >
                          <Grid item xs={12} md={3}>
                            <div className={BankStyles.itemWrap}>
                              <div className={BankStyles.labeltextNew}>
                                Name as Per Bank
                              </div>
                              <div className={BankStyles.value}>
                                {bankDetailsFetched.bankAccountName}
                              </div>
                            </div>
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <div className={BankStyles.itemWrap}>
                              <div className={BankStyles.labeltextNew}>
                                IFSC Code
                              </div>
                              <div className={BankStyles.value}>
                                {bankDetailsFetched.bankAccountIfsc}
                              </div>
                            </div>
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <div className={BankStyles.itemWrap}>
                              <div className={BankStyles.labeltextNew}>
                                Bank Account Number
                              </div>
                              <div className={BankStyles.value}>
                                {bankDetailsFetched.bankAccountNumber}
                              </div>
                            </div>
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <div className={BankStyles.itemWrapMobile}>
                              <div className={BankStyles.labeltextNew}>
                                Bank Name
                              </div>
                              <div className={BankStyles.value}>
                                {bankDetailsFetched.ifscDetails.name}
                              </div>
                            </div>
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <div className={BankStyles.itemWrap}>
                              <div className={BankStyles.labeltextNew}>
                                UPI ID
                              </div>
                              <div className={BankStyles.value}>
                                {bankDetailsFetched.payerVpa}
                              </div>
                            </div>
                          </Grid>
                          <Grid item xs={12} md={9}>
                            <div className={BankStyles.labeltextNew}>
                              Bank Address
                            </div>
                            <div className={BankStyles.value}>
                              {bankDetailsFetched.ifscDetails.address}
                            </div>
                          </Grid>
                        </Grid>
                      </div>

                      <div style={{ marginTop: "30px" }}></div>
                      {backdrop && <StartOverBackDrop />}
                    </Stack>
                  )}
                </div>

                <div className={BankStyles.buttonStack}>
                  <div className={BankStyles.buttonSectionRight}>
                    {upiID === "" &&
                      circularloader &&
                      agentPlatform !== "iOS" && (
                        <a
                          href={setuDetails.upiLink}
                          className={BankStyles.upiLinkMobile}
                        >
                          <Button
                            variant="contained"
                            sx={{ width: "100%" }}
                            onClick={handleMobilePaymentLink}
                            className={BankStyles.paybutton}
                          >
                            Pay Rs.1
                          </Button>
                        </a>
                      )}
                    <Button
                      variant="text"
                      sx={{
                        color: "var(--ds-text-primary)",
                        gap: "8px",
                      }}
                      onClick={() => {
                        if (pollingIntervalRef.current) {
                          clearInterval(pollingIntervalRef.current);
                        }
                        if (upiMode) {
                          handleBackClick();
                        } else {
                          navigate("/profile");
                        }
                      }}
                      className={BankStyles.backbutton}
                    >
                      <KeyboardBackspaceIcon /> Back
                    </Button>

                    {upiID !== "" && (
                      <Button
                        className={BankStyles.buttonBackStyles}
                        variant="outlined"
                        onClick={handleDoManuallyClick}
                        sx={{
                          color: "var(--ds-text-primary)",
                          background: "var(--ds-bg)",
                          width: { xs: "100%", sm: "187px" },
                          // height: { xs: "60px", sm: "50px" },
                        }}
                      >
                        Add Details Manually
                      </Button>
                    )}
                    {upiID !== "" && (
                      <LoadingButton
                        loading={loading}
                        variant="contained"
                        type="submit"
                        id="linkUsingIFSCContinueButton"
                        className={BankStyles.displayFetchedButtonContinue}
                        onClick={handleContinueNext}
                        sx={{
                          width: { xs: "100%", sm: "187px" },
                          // height: { xs: "60px", sm: "50px" },
                        }}
                      >
                        Continue
                      </LoadingButton>
                    )}
                  </div>
                </div>
              </div>
            )}
            {!displayManualEnter && !upiMode && (
              <div className={BankStyles.mainWrapper}>
                <div className={BankStyles.initialWrapper}>
                  <div className={BankStyles.headerSection}>
                    <p className={BankStyles.signup}>
                      <div className={BankStyles.mobileBack}>
                        <ArrowBackIosIcon
                          onClick={() => {
                            navigate("/profile");
                          }}
                        />
                      </div>
                      Link Your Bank Account{" "}
                      <div
                        className={BankStyles.mobileMenu}
                        onClick={() => {
                          setExpandMenu(!expandMenu);
                        }}
                      >
                        {expandMenu ? <CloseIcon /> : <MenuIcon />}
                      </div>
                    </p>
                    <ProgressBar />
                    <div
                      className={BankStyles.mobileexpandedMenu}
                      style={{
                        height: expandMenu ? "100%" : "0%",
                      }}
                    >
                      <div className={BankStyles.mobilemenuContent}>
                        <SideBar />
                      </div>
                    </div>
                    <p className={BankStyles.subText} style={{ width: "100%" }}>
                      Add your primary bank account for trading transactions.
                    </p>
                  </div>
                  <div className={BankStyles.mainConatiner}>
                    <div
                      className={BankStyles.subContainer}
                      onClick={() => {
                        const radio = document.getElementById("radio-a");
                        if (radio) {
                          radio.click();
                          setbgcolor1("var(--ds-card)");
                          setbgcolor2("var(--ds-bg)");
                        }
                      }}
                      style={{
                        // background: bgColor1,
                        border:
                          selectedValue === "a"
                            ? "1.5px solid var(--ds-text-secondary)"
                            : "",
                      }}
                    >
                      <div className={BankStyles.recommended}>
                        <img src={electric_bolt} /> Recommended
                      </div>
                      <div className={BankStyles.contentConatiner}>
                        <div className={BankStyles.subContentContainer}>
                          <div className={BankStyles.aligndiv}>
                            <div className={BankStyles.imagestyles}>
                              <img src={upiImage} />
                            </div>
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <p className={BankStyles.text}>
                                  {" "}
                                  Verify Bank Account Instantly
                                </p>
                              </div>
                              <p className={BankStyles.para}>
                                We’ll debit ₹1 for verification and refund it
                                after completion.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className={BankStyles.radioSection}>
                          <div>
                            <Radio
                              id="radio-a"
                              checked={selectedValue === "a"}
                              onChange={(event) => {
                                handleChange(event);
                                // console.log(event.target.value);
                              }}
                              value="a"
                              name="radio-buttons"
                              inputProps={{ "aria-label": "A" }}
                              sx={{
                                visibility: "hidden",
                                position: "absolute",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={BankStyles.subContainer}
                      onClick={() => {
                        const radio = document.getElementById("radio-b");
                        if (radio) {
                          radio.click();
                          setbgcolor2("var(--ds-card)");
                          setbgcolor1("var(--ds-bg)");
                        }
                      }}
                      style={{
                        // marginTop: "20px",
                        // background: bgColor2,
                        border:
                          selectedValue === "b"
                            ? "1.5px solid var(--ds-text-secondary)"
                            : "",
                      }}
                    >
                      <div className={BankStyles.contentConatiner}>
                        <div className={BankStyles.subContentContainer}>
                          <div className={BankStyles.aligndiv}>
                            <div className={BankStyles.imagestyles}>
                              <img src={manualImage} />
                            </div>
                            <div>
                              <p className={BankStyles.text}>
                                {" "}
                                Add details manually
                              </p>
                              <p className={BankStyles.para}>
                                Enter your bank name, account number, and IFSC
                                code.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className={BankStyles.radioSection}>
                          <div>
                            <Radio
                              id="radio-b"
                              checked={selectedValue === "b"}
                              onChange={(event) => {
                                handleChange(event);
                                //  console.log(event.target.value);
                              }}
                              value="b"
                              name="radio-buttons"
                              inputProps={{ "aria-label": "B" }}
                              sx={{
                                visibility: "hidden",
                                position: "absolute",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={BankStyles.buttonStack}>
                  <div className={BankStyles.buttonSectionRight}>
                    <Button
                      variant="text"
                      sx={{
                        color: "var(--ds-text-primary)",
                        gap: "8px",
                      }}
                      onClick={() => {
                        navigate("/profile");
                      }}
                      className={BankStyles.backbutton}
                    >
                      <KeyboardBackspaceIcon /> Back
                    </Button>
                    {selectedValue === "a" ? (
                      <LoadingButton
                        variant="contained"
                        type="submit"
                        id="linkUsingIFSCContinueButton"
                        className={BankStyles.approveButton}
                        onClick={handleContinuewithUPI}
                        // sx={{ height: "50px" }}
                      >
                        Continue securely with UPI
                      </LoadingButton>
                    ) : (
                      <LoadingButton
                        variant="contained"
                        type="submit"
                        id="linkUsingIFSCContinueButton"
                        className={BankStyles.approveButton}
                        onClick={handleContinueManually}
                        // sx={{ height: "50px" }}
                      >
                        Add details manually
                      </LoadingButton>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
